import { SearchableCheckList } from '@/components/common/SearchableCheckList'
import type { CheckListItem } from '@/components/common/CheckList'

interface Props {
  label: string
  searchLabel: string
  items: CheckListItem[]
  selectedIds: (number | string)[]
  onChange: (ids: (number | string)[]) => void
  emptyText: string
  /** When set, a checkbox is shown that selects/deselects all currently visible items. */
  selectAllLabel?: string
}

/** One column of the group dialog's three-column selection: taller list, uppercase heading. */
export function SelectColumn({
  label,
  searchLabel,
  items,
  selectedIds,
  onChange,
  emptyText,
  selectAllLabel,
}: Props) {
  return (
    <SearchableCheckList
      label={label}
      searchLabel={searchLabel}
      items={items}
      selected={selectedIds}
      onChange={onChange}
      emptyText={emptyText}
      selectAllLabel={selectAllLabel}
      labelClassName="text-xs text-muted-foreground font-semibold uppercase tracking-wider"
      listClassName="h-[29rem] rounded-md border p-2"
    />
  )
}
